export const errors = {
  notFoundTitle: "Página no encontrada",
  notFoundDescription: "La dirección no existe o ya no está disponible.",
  forbiddenTitle: "Sin acceso",
  forbiddenDescription: "No tienes permisos para ver esta página.",
  backHome: "Volver al inicio",
  unexpectedTitle: "Ha ocurrido un error",
  unexpectedDescription:
    "Vuelve a intentarlo. Si el problema sigue, avisa a soporte.",
  reloadDescription:
    "Recarga la página. Si el problema sigue, avisa a soporte.",
  network: "No se ha podido conectar con el servidor.",
};
